import { createContext, useContext, useState } from 'react';
import { authLogin } from '../services/AuthAPI'

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  const [user, setUser] = useState(null);

  const login = async (username, password) => {
    try {
      const response = await authLogin(username, password);
      console.log(response);
      localStorage.setItem('access_token', response.access_token);
      setUser({ username });
      return true;
    } catch (error) {
      console.error('Login failed:', error);
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('access_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
